import type { Messages } from '../shape';

export const ui = {
  confirmDefault: 'ОК',
} satisfies Messages['ui'];
